/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Queues_Is_DefaultInputs */

const en_tables_queues_is_default = /** @type {(inputs: Tables_Queues_Is_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Default`)
};

const de_tables_queues_is_default = /** @type {(inputs: Tables_Queues_Is_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist Standard`)
};

/**
* | output |
* | --- |
* | "Default" |
*
* @param {Tables_Queues_Is_DefaultInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_queues_is_default = /** @type {((inputs?: Tables_Queues_Is_DefaultInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Queues_Is_DefaultInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_queues_is_default(inputs)
	return de_tables_queues_is_default(inputs)
});